import { createAsyncAction } from 'typesafe-actions'

export const getTrainingLogs = createAsyncAction(
  'Get_Training_Logs__Request',
  'Get_Training_Logs__Success',
  'Get_Training_Logs__Failure',
)<void, any, Error>()
